import hero1 from '../assest/slider1.webp';
import hero2 from '../assest/slide2.webp';
import hero3 from '../assest/slide3.webp';
import hero4 from '../assest/slide4.webp';
import hero5 from '../assest/slide5.webp';
import hero6 from '../assest/slide6.webp';
import hero7 from '../assest/slide7.webp';
import hero8 from '../assest/slide8.webp';
import hero9 from '../assest/slide9.webp';
import hero10 from '../assest/slide10.webp';
import hero11 from '../assest/slide11.webp';
import hero12 from '../assest/slide12.webp';
import hero13 from '../assest/slide13.webp';
import hero14 from '../assest/slide14.webp';
import hero15 from '../assest/slide15.webp';
import hero16 from '../assest/slide16.webp';

import image1 from '../assest/proimg1.webp';
import image2 from '../assest/proImg2.webp';
import image3 from '../assest/proImg3.webp';
import image4 from '../assest/proImg4.webp';
import image5 from '../assest/proImg5.webp';
import image6 from '../assest/proImg6.webp';
import image7 from '../assest/proImg7.webp';
import image8 from '../assest/proimg8.webp';




export const NavData = [
  {
    id: '1',
    heading: "Home",
    url: "/#",
    second_heading: [],
    third_heading: [],
  },

  {
    id: '2',
    heading: "About Me",
    url: "/#about",
    second_heading: [],
    third_heading: [],
  },
  {
    id: '3',
    heading: "My Projects",
    url: "/#project",
    second_heading: [],
    third_heading: [],
  },
  {
    id: '4',
    heading: "Designs",
    url: "/service",
    second_heading: [],
    third_heading: [],
  },
  {
    id: '5',
    heading: "Photography",
    url: "/photography",
    second_heading: [],
    third_heading: [],
  },
  {
    id: '6',
    heading: "Contact",
    url: "/#contact",
    second_heading: [],
    third_heading: [],
  },
];

export const slides = [
  {
    image: (hero1),
    title: "Because Every Moment Matters",
    description: "Turning real emotions into timeless photographs you’ll cherish for a lifetime."
  },
  {
    image: (hero2),
    title: "Where Emotion Meets Art",
    description: "From weddings to pre-shoots, we capture your story exactly as it feels."
  },
  {
    image: (hero3),
    title: "Capture the Real You",
    description: "Authentic, cinematic photography for life’s most meaningful moments."
  },
  {
    image: (hero4),
    title: "Turning Life into Art",
    description: "Elegant wedding and bridal photography with attention to every detail."
  },
  {
    image: (hero5),
    title: "Memories You Can Feel",
    description: "Birthdays, parties, graduations, and celebrations—captured beautifully."
  },
  {
    image: (hero6),
    title: "Your Story Through Our Lens",
    description: "Creative photography that blends passion, storytelling, and style."
  },
  {
    image: (hero7),
    title: "Moments That Last Forever",
    description: "Fashion, model, and portrait sessions designed to highlight your true personality."
  },
  {
    image: (hero8),
    title: "Every Love Story Deserves to Be Told",
    description: "From intimate moments to grand events, we frame memories with purpose."
  },
  {
    image: (hero9),
    title: "More Than Photos — Memories",
    description: "Natural, candid photography that brings your moments back to life."
  },
  {
    image: (hero10),
    title: "Your Special Day, Perfectly Framed",
    description: "Professional photography for weddings, events, and every milestone in between."
  },
  {
    image: (hero11),
    title: "Moments Fade. Photographs Don’t",
    description: "Preserve your most important memories with timeless photography."
  },
  {
    image: (hero12),
    title: "Where Your Moments Become Masterpieces",
    description: "FProfessional photography crafted with passion, precision, and creativity"
  },
  {
    image: (hero13),
    title: "Celebrate Life in Every Frame",
    description: "From birthdays to milestones, we capture your joy beautifully"
  },
  {
    image: (hero14),
    title: "Feel the Moment Again",
    description: "Candid, cinematic photography that brings emotions back to life"
  },
  {
    image: (hero15),
    title: "Unforgettable Moments Deserve Stunning Photos",
    description: "We make your events look and feel extraordinary"
  },
  {
    image: (hero16),
    title: "Capturing Life One Story at a Time",
    description: "From intimate gatherings to grand celebrations, we frame it all"
  },
];



export const com = Object.freeze({
  firstname: "Abilasha",
  lastname: "Wickramarathna",
  position: ["Web Developer", "Frontend Developer", "UX/UI Designer", "Software Engineer", "Photographer", "Videographer", "Graphic Designer",],
  mail: "abilasha@abiwic.com",
  mail2: "abiwickramarathna@icloud.com",
  tel: "+94 (76) 8309 969",
  tel2: "+94 (76) 8309 969",
  location: "Katunayaka, Sri Lanka",
});

export const label = Object.freeze({
  btn_des1: "Let's Talk",
  btn_des2: "Check Resume",
  btn_des3: "Send Mail",
  labe1: 'Mail',
  label2: 'Call',
  label3: 'Visit',
  label4: "Load More...",
  links: "https://drive.google.com/file/d/1btvDispyXSmvvnbdUN0eHPVUezl-Kx0H/view?usp=drive_link"
});

export const sec1 = Object.freeze({
  tag1: "Hello, my name is",
});

export const aboutSec = Object.freeze({
  des2: "I build experiences, capture moments, and design stories",
  des1: "I blend code, design, and photography to turn ideas into experiences and moments into stories. From crafting seamless websites and striking visuals to capturing memories that last, every project is created with purpose, creativity, and a passion for making an impression.",
  dec3: "Did you enjoyed, Make Your Sign here",
})


export const sec2 = Object.freeze({
  title: "About Me",
  aboutDes: "I’m a driven and forward-thinking creative professional with a passion for technology, design, and visual storytelling. I approach every project with curiosity, energy, and responsibility, embracing challenges as opportunities to grow, push creative boundaries, and turn ideas into meaningful results.",
  subTitle1: "my profile",
  subTitle2: "education",
  subTitle3: "coding journey",
  subTitle4: "photography",
  subTitle5: "SKILLS",
  statics1: "Projects",
  statics2: "Years",
  statics3: "clients",
  sValue1: "30+",
  sValue2: "5+",
  sValue3: "70+",
  word1: "Click to see",
  word2: "See my latest project",
  education: "BEng IN SOFTWARE ENGINEERING "
});


export const skills = [
  {
    skill: "React Js"
  },
  {
    skill: "Node Js"
  },
  {
    skill: "Java Script"
  },
  {
    skill: "Html"
  },
  {
    skill: "Css"
  },
  {
    skill: "Wordpress"
  },
  {
    skill: "MySQL"
  },
  {
    skill: "MongoDB"
  },
  {
    skill: "Adobe Photoshop"
  },
  {
    skill: "Figma"
  },
  {
    skill: "Premire Pro"
  },
  {
    skill: "Lightroom"
  },
  {
    skill: "Adobe XD"
  },
];

export const codeJourney = [
  {
    pos: "Web / Software Engineer",
    com: "VS Fresh (pvt) Ltd (2026 - Present)"
  },
  {
    pos: "Web / Software Engineer",
    com: "JAPC (pvt) Ltd (2024 - 2026)"
  },
  {
    pos: "React Frontend Engineer",
    com: "SML Technology Solution (2022 - 2024)"
  },
  {
    pos: "Freelance Web Developer",
    com: "(2022 - Present)"
  },
  {
    pos: "System Analysis",
    com: "SML technology Solution (2018 - 2022)"
  },
];

export const sec3 = Object.freeze({
  title: "Recently Projects",
  des1: "Our recent projects represent a blend of strategic insight and creative execution. Every engagement is approached with precision, ensuring results that resonate, perform, and endure.",

});

export const proData = [
  {
    heading: "OzzyFind",
    url: "https://www.ozzyfind.com/",
    tag: "- Business Directory",
    img: (image1)
  },
  {
    heading: "The Vault",
    url: "https://www.thevault.lk/",
    tag: "-Private Theater",
    img: (image2)
  },
  {
    heading: "Devine Nature Tea",
    url: "https://divinenature.lk/",
    tag: "- business profile",
    img: (image1)
  },
  {
    heading: "Decode Media Pro",
    url: "https://decodemediapro.com/",
    tag: "- business profile",
    img: (image2)
  },
  {
    heading: "KIDDOLEGO",
    url: "https://kiddobricks.lk/",
    tag: "- e-commerce",
    img: (image3)
  },
  {
    heading: "Drone Eye",
    url: "https://dronei.abiwic.com/",
    tag: "- e-commerce",
    img: (image4)
  },
  {
    heading: "Wild Life Panting",
    url: "https://wildlife.abiwic.com/",
    tag: "- e-commerce",
    img: (image5)
  },
  {
    heading: "SpicyRides",
    url: "https://spicy.abiwic.com/",
    tag: "- Booking website",
    img: (image8)
  },
  {
    heading: "True Organic",
    url: "https://thetrueorganics.com/",
    tag: "- e-commerce",
    img: (image6)
  },
  {
    heading: "Tropical Goodness",
    url: "https://tropicalgoodness.co.nz/",
    tag: "- e-commerce",
    img: (image7)
  },

];

export const contact = Object.freeze({
  lets: "Let's ",
  connect: "Connect",
  phone: "Phone",
  mail: "E-Mail",
  address: "Location",
});

export const footerData = Object.freeze({
  wording1: 'Follow Me',
  copyright: '©2026 Abilasha Wickramarathna. All Rights Reserved'
});

